import { render } from "./QuickstartContract.vue?vue&type=template&id=534684ca"
import script from "./QuickstartContract.vue?vue&type=script&lang=js"
export * from "./QuickstartContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__